import { render, staticRenderFns } from "./goods-list.vue?vue&type=template&id=9c460dea&scoped=true&"
import script from "./goods-list.vue?vue&type=script&lang=js&"
export * from "./goods-list.vue?vue&type=script&lang=js&"
import style0 from "./goods-list.vue?vue&type=style&index=0&id=9c460dea&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c460dea",
  null
  
)

export default component.exports